export default "__VITE_ASSET__3895e46b__"